import {
  InformacionEmpresaEjecDetalle,
  InformacionEmpresaEjecDetalleFiltro,
  InformacionEmpresaEjec,
  InformacionEmpresaEjecFiltro,
  InformacionEmpresaHg,
  InformacionEmpresaHgFiltro,
  InformacionEmpresaInf,
  InformacionEmpresaInfDetalle,
  InformacionEmpresaInfDetalleFiltro,
  InformacionEmpresaInfFiltro,
  InformacionEmpresaOc,
  InformacionEmpresaOcDetalle,
  InformacionEmpresaOcDetalleFiltro,
  InformacionEmpresaOcFiltro,
  InformacionEmpresaProg,
  InformacionEmpresaProgDetalle,
  InformacionEmpresaProgDetalleFiltro,
  InformacionEmpresaProgFiltro
} from '../../model/informacion-empresa/informacion-empresa-oc';
import { CatalogoOption } from '../../model/catalogo/catalogo';

export abstract class InformacionEmpresaRepository {
  abstract listarOrdenadoConsultoria(filtro: InformacionEmpresaOcFiltro): Promise<InformacionEmpresaOc[]>;
  abstract listarDetalleOrdenadoConsultoria(filtro: InformacionEmpresaOcDetalleFiltro): Promise<InformacionEmpresaOcDetalle[]>;
  abstract listarHistorialGestiones(filtro: InformacionEmpresaHgFiltro): Promise<InformacionEmpresaHg[]>;
  abstract listarCitasProgramadas(filtro: InformacionEmpresaProgFiltro): Promise<InformacionEmpresaProg[]>;
  abstract listarServiciosEntregados(filtro: InformacionEmpresaEjecFiltro): Promise<InformacionEmpresaEjec[]>;
  abstract listarInformesEntregados(filtro: InformacionEmpresaInfFiltro): Promise<InformacionEmpresaInf[]>;
  abstract listarDetalleInformesEntregados(filtro: InformacionEmpresaInfDetalleFiltro): Promise<InformacionEmpresaInfDetalle[]>;
  abstract listarDetalleServiciosEntregados(filtro: InformacionEmpresaEjecDetalleFiltro): Promise<InformacionEmpresaEjecDetalle[]>;
  abstract listarDetalleCitasProgramadas(filtro: InformacionEmpresaProgDetalleFiltro): Promise<InformacionEmpresaProgDetalle[]>;
  abstract listarTiposCitaServicio(): Promise<CatalogoOption[]>;
  abstract listarEstadosCitaProgramadas(): Promise<CatalogoOption[]>;
}
